import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { IMAGES, VALUES } from "../../lib/content";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-[#0C1812]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative h-[480px] hidden lg:block"
        >
          <div className="absolute top-0 left-0 w-[70%] h-[320px] rounded-2xl overflow-hidden border border-[#D4AF37]/20">
            <img src={IMAGES.aboutInterior} alt="Managed interior" className="w-full h-full object-cover" />
          </div>
          <div className="absolute bottom-0 right-0 w-[58%] h-[300px] rounded-2xl overflow-hidden border border-[#D4AF37]/30 shadow-2xl">
            <img src={IMAGES.aboutHome} alt="Managed residence" className="w-full h-full object-cover" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <span className="overline">About Us</span>
          <h2 className="font-serif-display text-[#FDFBF7] text-3xl md:text-5xl tracking-tight mt-4 leading-tight">
            Lasting value,<br />responsibly built.
          </h2>
          <div className="mt-6 space-y-5 text-[#A3B1A8] text-base md:text-lg leading-relaxed">
            <p>
              North Emerald Holdings LLC is a property development and management company focused on acquiring,
              improving, and managing properties that bring lasting value to the neighborhoods and communities we serve.
            </p>
            <p>
              We believe that well-maintained and thoughtfully improved properties can make a meaningful difference
              in a community. Our approach is centered on identifying properties with potential, making strategic
              improvements, and providing responsible, reliable management that supports their long-term success.
            </p>
            <p>
              From property acquisition and development to ongoing management and maintenance, North Emerald Holdings
              LLC is committed to quality, integrity, and responsible growth. Our goal is to create welcoming,
              well-cared-for properties while contributing to stronger neighborhoods and building long-term value
              for the future.
            </p>
          </div>

          <div className="mt-10 space-y-6">
            {VALUES.map((v) => (
              <div key={v.title} className="flex gap-4">
                <div className="mt-1 w-6 h-6 rounded-full bg-[#D4AF37]/15 flex items-center justify-center shrink-0">
                  <Check size={14} className="text-[#D4AF37]" />
                </div>
                <div>
                  <h3 className="text-[#FDFBF7] font-semibold text-lg">{v.title}</h3>
                  <p className="text-[#A3B1A8] text-sm mt-1 leading-relaxed">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
